module.exports = __webpack_public_path__ + "static/media/search_no_result.cd2318be.png";